"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const SvgClipboard = props => (0, jsx_runtime_1.jsxs)("svg", Object.assign({
  "data-name": "Regular 1.5px/clipboard",
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props, {
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Regular 1.5px/clipboard background",
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }, void 0), (0, jsx_runtime_1.jsx)("path", {
    d: "M15 18.333H5a2.5 2.5 0 01-2.5-2.5V5A2.5 2.5 0 015 2.5h3.333a1.667 1.667 0 113.334 0H15A2.5 2.5 0 0117.5 5v10.833a2.5 2.5 0 01-2.5 2.5zM5 3.75A1.252 1.252 0 003.75 5v10.833A1.252 1.252 0 005 17.083h10a1.252 1.252 0 001.25-1.25V5A1.252 1.252 0 0015 3.75h-1.667V5a.834.834 0 01-.833.833h-5A.834.834 0 016.667 5V3.75zm2.917 0v.833h4.166V3.75h-.416a1.252 1.252 0 01-1.25-1.25.417.417 0 00-.833 0 1.243 1.243 0 01-1.13 1.244l-.121.006z"
  }, void 0), (0, jsx_runtime_1.jsx)("path", {
    "data-name": "Vector 391 (Stroke)",
    d: "M6.625 9h6.667a.625.625 0 010 1.25H6.625a.625.625 0 010-1.25z"
  }, void 0), (0, jsx_runtime_1.jsx)("path", {
    "data-name": "Vector 392 (Stroke)",
    d: "M6.667 12H10a.625.625 0 010 1.25H6.667a.625.625 0 010-1.25z"
  }, void 0)]
}), void 0);

exports.default = SvgClipboard;